module.exports = __webpack_public_path__ + "static/img/face-laugh.d693e6f.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/web/face-laugh.gif
// module id = sFtI
// module chunks = 0